module.exports = __webpack_public_path__ + "img/Gallery_3_05.6a1ff648.jpeg";